import { APP_INITIALIZER, ApplicationConfig, isDevMode } from '@angular/core';
import { provideRouter, withDebugTracing } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { provideMarkdown } from 'ngx-markdown';
import { httpRequestInterceptor } from './core/interceptors/http-request.interceptor';
import { httpUnauthorizedRequestInterceptor } from './core/interceptors/http-unauthorized-request.interceptor';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco, TranslocoService } from '@jsverse/transloco';
import { preloadLang } from "./preload-lang";
import { TranslationPreloaderService } from './translation-preloader.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes /*, withDebugTracing()*/),
    provideAnimations(),
    provideMarkdown(),
    provideHttpClient(
      withInterceptors([httpRequestInterceptor, httpUnauthorizedRequestInterceptor]),
      withFetch(),
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN',
      }),
    ),
    provideTransloco({
      config: {
        availableLangs: ['fr', 'en', 'es'],
        defaultLang: 'fr',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: preloadLang,
      deps: [TranslationPreloaderService],
      multi: true,
    },
  ],
};
